module.exports = __webpack_public_path__ + "img/mood.72dbf2ed.svg";